/**
 * MarketingTab — top-level tab panel for the unit's Marketing tab.
 * Composes MarketingEditor (the same editor the listing guide uses) and PhotoGrid vertically.
 */

import { MarketingEditor } from './MarketingEditor';
import { PhotoGrid } from './PhotoGrid';
import { PageSection } from '../layout/index';

interface Props {
  unitId: string;
}

export function MarketingTab({ unitId }: Props) {
  return (
    <div data-testid="marketing-tab-content">
      <PageSection title="Marketing Profile">
        <MarketingEditor unitId={unitId} />
      </PageSection>

      <PageSection title="Photos">
        <PhotoGrid unitId={unitId} />
      </PageSection>
    </div>
  );
}
